import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export const mimeTypeExtensions = [
  { type: 'application/pdf', extension: 'pdf' },
  { type: 'text/csv', extension: 'csv' },
  { type: 'application/msword', extension: 'doc' },
  { type: 'image/*', extension: 'imagen' },
  { type: 'application/zip', extension: 'zip' },
  { type: 'application/x-zip-compressed', extension: 'zip' }
];

@Component({
  selector: 'siu-upload-archivozip',
  templateUrl: './upload-archivozip.component.html',
  styleUrls: ['./upload-archivozip.component.css']
})
export class UploadArchivoZipComponent implements OnInit {

  @Input() fileLimit: any;
  @Output() upLoadFile: EventEmitter<File>;
  @Output() onWhenAddingFileFailed: EventEmitter<string>;
  @Input() allowedMimeType: string[];
  @Output() removeFile: EventEmitter<number>;

  files: any = [];
  fileSize: any;
  type = [".zip"];

  constructor() {
    this.upLoadFile = new EventEmitter();
    this.onWhenAddingFileFailed = new EventEmitter();
    this.removeFile = new EventEmitter();
  }

  ngOnInit() {
  }

  uploadFile(event: any) {

    if (event.length > 1)//EVITAMOS SUBIR MAS DE UN ARCHIVO
    {
      let message = 'Sólo se acepta subir un documento';
      this.onWhenAddingFileFailed.emit(message);
      return false;
    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element.name);

      if (this.files.length > 0) {
        if (element) {
          //llamamos al metodo de verficacon el tipo de documento ingresado
          this.upLoadTypeFile(element);
        }
      }
    }
  }

  upLoadTypeFile(element) {
    if (element) {
      if ((element.type.toString() === mimeTypeExtensions[4].type.toString()) || (element.type.toString() === mimeTypeExtensions[5].type.toString())) {
        //2° Validamos el limite permitido si excedio
        this.upLoadLimitFile(element);
      }
      else {
        let message = 'El Tipo de documento '+element.type.toString()+' es incorrecto sólo se acepta archivo .ZIP('+mimeTypeExtensions[4].type.toString()+')';
        this.deleteAttachment(0);
        this.upLoadFile.emit(null);
        this.onWhenAddingFileFailed.emit(message);
        return false;
      }
    }
  }

  upLoadLimitFile(element) {
    if (element) {
      if (element.size > this.fileLimit) {
        let message = 'El archivo superó el límite permitido';
        //eliminamos el archivo
        this.deleteAttachment(0);
        this.upLoadFile.emit(null);
        this.onWhenAddingFileFailed.emit(message);
        return false;
      }
      else {
        let message = ' Se cargó correctamente el documento';
        this.upLoadFile.emit(element);
        this.onWhenAddingFileFailed.emit(message);
        return true;
      }
    }
  }

  upFile = (item, filter) => {
    let message = '';
    switch (filter.name) {
      case 'mimeType':
        message = `
        Sólo se permite archivo en formato
        ${this.allowedMimeType.map((i) =>
          (mimeTypeExtensions.find(x => x.type === i) || { extension: i }).extension).join(', ')}`;
        console.log('message mimeType');
        console.log(message);
        break; 
      case 'fileSize':
        console.log('message fileSize');
        console.log(message);
        break;
      default:
        message = `Error al adjuntar el archivo ${item.name}`;
        console.log('message default');
        console.log(message);
        break;
    }
    this.onWhenAddingFileFailed.emit(message);
  }

  deleteAttachment(index) {
    this.files.splice(index, 1);
    this.removeFile.emit(index);
  }
}
